import axios from 'axios';
import { ReservablePipelineEvents } from '../../../../../shared/lib/reserve';
import { useQuery, UseQueryOptions } from './useQuery';
import { useApp } from '../designs/paper/context/AppContext';

interface UseExperiencesParams {
  propertyId: string;
  startDate?: string;
  endDate?: string;
}

type UseExperiencesOptions = UseQueryOptions<ReservablePipelineEvents, Error>;

/**
 * Hook to fetch all experiences for a brand
 * @param propertyId - The property ID to fetch experiences for
 * @param startDate - Optional start date in YYYY-MM-DD format (defaults to today)
 * @param endDate - Optional end date in YYYY-MM-DD format (defaults to today + 15 days)
 * @param options - Additional react-query options
 */
export function useExperiences(
  { propertyId, startDate, endDate }: UseExperiencesParams,
  options?: UseExperiencesOptions
) {
  const { config } = useApp();

  return useQuery<ReservablePipelineEvents, Error>(
    ['experiences', propertyId, startDate, endDate],
    async () => {
      const response = await axios.get<ReservablePipelineEvents>(config.experiencesUrl, {
        params: {
          startDate,
          endDate,
        },
      });
      return response.data;
    },
    options
  );
}
